export const PERMISSIONS = {}

export const RESULTS = {
    UNAVAILABLE: 'unavailable',
    BLOCKED: 'blocked',
    DENIED: 'denied',
    GRANTED: 'granted',
    LIMITED: 'limited',
  }

export const check = () => { return RESULTS.DENIED }

export const request = () => { return RESULTS.DENIED }

const Permissions = {
    PERMISSIONS, 
    RESULTS, 
    check, 
    request
}

export default Permissions